import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  width: 80vw;
  max-width: 460px;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    h3 {
      margin: 0;
      font-size: 20px;
      color: ${ ({ theme }) => theme.colors.primary };
      text-transform: uppercase;
    }

    .close {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .trip {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-bottom: 4px;
    border-bottom: 1px solid ${ ({ theme }) => theme.colors.greyLight };

    .when {
      color: ${ ({ theme }) => theme.colors.greyDark };
      font-size: 14px;
    }
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      font-size: 14px;
      color: ${ ({ theme }) => theme.colors.greyDark };
    }

    input {
      font-family: inherit;
      font-size: 16px;
      padding: 10px 12px;
      border-radius: 8px;
      border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      background-color: ${ ({ theme }) => theme.colors.white };
      color: ${ ({ theme }) => theme.colors.black };

      &:focus {
        outline: none;
        border-color: ${ ({ theme }) => theme.colors.primary };
      }

      &.error {
        border-color: ${ ({ theme }) => theme.colors.red };
      }
    }

    /* the shared Select caps itself at 100px, too narrow for these labels */
    .select-container {
      width: 100%;
      max-width: none;
    }
  }

  .dates {
    display: flex;
    flex-direction: row;
    gap: 12px;

    .field {
      flex: 1;
      min-width: 0;
    }
  }

  .error-text {
    margin: 0;
    color: ${ ({ theme }) => theme.colors.red };
    font-size: 13px;
  }

  .week-days {
    display: flex;
    flex-direction: row;
    gap: 6px;
    flex-wrap: wrap;

    .day {
      min-width: 38px;
      padding: 8px 6px;
      border-radius: 20px;
      border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      background: none;
      font-family: inherit;
      font-size: 14px;
      cursor: pointer;
      color: ${ ({ theme }) => theme.colors.black };

      &.selected {
        border-color: ${ ({ theme }) => theme.colors.greenRadio };
        background-color: ${ ({ theme }) => theme.colors.lightGreen };
        font-weight: 700;
      }
    }
  }

  footer {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`
